import React, { useEffect, useState } from "react";
import BASE_URL from "../../config";

export default function Contactus() {
  const [contacts, setContacts] = useState([]);

  const [form, setForm] = useState({
    id: "",
    office_name: "",
    address: "",
    phone1: "",
    phone2: "",
    timing: "",
  });

  // FETCH ALL CONTACTS
  const fetchContacts = () => {
    fetch(`${BASE_URL}/api/getContact.php`)
      .then((res) => res.json())
      .then((data) => {
        setContacts(data);
      });
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  // INPUT CHANGE
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // SAVE CONTACT
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    fetch(`${BASE_URL}/api/saveContact.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then((msg) => {
        alert(msg);

        setForm({
          id: "",
          office_name: "",
          address: "",
          phone1: "",
          phone2: "",
          timing: "",
        });

        fetchContacts();
      });
  };

  // EDIT
  const handleEdit = (item) => {
    setForm(item);
  };

  // DELETE
  const handleDelete = (id) => {
    if (!window.confirm("Delete this contact?")) return;

    const formData = new FormData();
    formData.append("id", id);

    fetch(`${BASE_URL}/api/deleteContact.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then((msg) => {
        alert(msg);
        fetchContacts();
      });
  };

  return (
    <>
      <div className="form-container">
        <h2>સંપર્ક વિગતો</h2>

        <form className="form" onSubmit={handleSubmit}>
          <label>ઓફિસનું નામ</label>
          <input
            type="text"
            name="office_name"
            value={form.office_name}
            onChange={handleChange}
            required
          />

          <label>સરનામું</label>
          <textarea
            rows="3"
            name="address"
            value={form.address}
            onChange={handleChange}
            required
          />

          <label>મોબાઇલ નંબર-1</label>
          <input
            type="text"
            name="phone1"
            value={form.phone1}
            onChange={handleChange}
            required
          />

          <label>મોબાઇલ નંબર-2</label>
          <input
            type="text"
            name="phone2"
            value={form.phone2}
            onChange={handleChange}
          />

          <label>કામકાજ નો સમય </label>
          <input
            type="text"
            name="timing"
            value={form.timing}
            onChange={handleChange}
            required
          />

          <button type="submit">{form.id ? "Update" : "Save"}</button>
        </form>
      </div>
      <hr />

      <h4>બધી શાખાઓ </h4>

      {contacts.map((item) => (
        <div
          key={item.id}
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          <h4>{item.office_name}</h4>

          <p>{item.address}</p>

          <p>{item.phone1}</p>

          <p>{item.phone2}</p>

          <p>{item.timing}</p>

          <button
            style={{
              background: "#9b9214",
              color: "#fff",
              border: "none",
              padding: "5px 10px",
              cursor: "pointer",
              width: "100px",
            }}
            onClick={() => handleEdit(item)}
          >
            Edit
          </button>

          <button
            style={{
              background: "#b41212",
              color: "#fff",
              border: "none",
              padding: "5px 10px",
              cursor: "pointer",
              width: "100px",
              marginLeft: "30px",
            }}
            onClick={() => handleDelete(item.id)}
          >
            Delete
          </button>
        </div>
      ))}
    </>
  );
}
